import { Col, Row, Tag, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import companyDefaultLogo from '../../../assets/images/company-default-logo.png';
import { JobStatusMap } from '../../../constants/job-status';
import { locationToAddress } from '../../../utils/strings';
import { JobSummaryItem, LogoBox, TitleLink } from '../styles';
import { JobTypeTag, TitledValue } from '../../widgets';

export const getExpDisplay = yearsOfExp => {
	const min = yearsOfExp.min;
	const max = yearsOfExp.max;
	if (max == 99) return `${min}+`;
	else if (max == min) return `${min}+`;
	else return `${min} - ${max}`;
};

export default function JobDescriptionCard(props) {
	const { job } = props;
	const location = props.companyLocation ? locationToAddress(props.companyLocation) : null;
	return (
		<Link to={`/dashboard/job/${job._id}`}>
			<JobSummaryItem gutter={8}>
				<Col xs={0} md={3} xl={2}>
					<LogoBox src={job.company?.logo || props.companyLogo || companyDefaultLogo} alt="logo" />
				</Col>
				<Col xs={19} md={18}>
					<Row>
						<TitleLink style={{ wordBreak: 'break-all' }} to={`/dashboard/job/${job._id}`}>
							{job.title}{' '}
							<Tag color={JobStatusMap[job.status]} className="ms-2">
								{job.status}
							</Tag>
						</TitleLink>
					</Row>
					<Row className="summary-row">
						<Col xs={24} md={8}>
							<TitledValue desc="Location:">{location || 'NA'}</TitledValue>
						</Col>
						<Col xs={24} md={8}>
							<TitledValue desc="Career Level:">{job.careerLevel || 'NA'}</TitledValue>
						</Col>
						<Col xs={24} md={8}>
							<TitledValue desc="Experience:">
								{job.yearsOfExp ? `${getExpDisplay(job.yearsOfExp)} years` : 'NA'}
							</TitledValue>
						</Col>
						<Col xs={24} md={8}>
							<TitledValue desc="Vacancies:">{job.vacancies || 'NA'}</TitledValue>
						</Col>
					</Row>

					<Row className="summary-row">
						<Col xs={24}>
							<TitledValue desc="Keywords:">{job.keywords.join(', ') || 'NA'}</TitledValue>
						</Col>
					</Row>
				</Col>
				<Col xs={5} md={3} className="d-flex flex-column align-items-center">
					<Row className="text-center">
						{job.jobType.map(t => (
							<JobTypeTag type={t}>{t}</JobTypeTag>
						))}
						<Tooltip title={dayjs().format('YYYY-MM-DD HH:mm:ss')}>
							<p className="text-faded job-head__date">{dayjs(job.createdAt).fromNow()}</p>
						</Tooltip>
					</Row>
				</Col>
			</JobSummaryItem>
		</Link>
	);
}
